import EventParticipantStatus from 'app/frontend/types/custom/EventParticipantStatus'
import { cva, type VariantProps } from 'class-variance-authority'
import {
  Check,
  CircleDashed,
  CircleSlash2,
  Clock4,
  MessageCircleQuestion,
  PauseCircle,
  Trash2,
  X,
} from 'lucide-react'

export const eventStatusColorClassByStatus: Record<
  EventParticipantStatus,
  string
> = {
  absent: 'text-destructive-foreground',
  present: 'text-success-foreground',
  tentative: 'text-warning-foreground',
  late: 'text-warning-foreground',
  standby: 'text-info-foreground',
  missing: 'text-destructive-foreground',
  removed: 'text-muted-foreground',
  unknown: 'text-muted-foreground',
}

const eventStatusIconVariants = cva('', {
  variants: {
    status: eventStatusColorClassByStatus,
    size: {
      small: 'w-4 h-4 min-w-4 min-h-4',
      medium: 'w-6 h-6 min-w-6 min-h-6',
      large: 'w-8 h-8 min-w-8 min-h-8',
    },
  },
  defaultVariants: {
    size: 'small',
  },
})

export const getEventStatusColorClass = (status: EventParticipantStatus) =>
  eventStatusColorClassByStatus[status]

type EventStatusIconProps = VariantProps<typeof eventStatusIconVariants> & {
  status: EventParticipantStatus
}

const EventStatusIcon = ({ status, size }: EventStatusIconProps) => {
  const Icon = {
    present: Check,
    absent: X,
    tentative: MessageCircleQuestion,
    late: Clock4,
    unknown: CircleDashed,
    standby: PauseCircle,
    missing: CircleSlash2,
    removed: Trash2,
  }[status]

  if (!Icon) {
    return null
  }

  return <Icon className={eventStatusIconVariants({ status, size })} />
}

export default EventStatusIcon
